module.exports = __webpack_public_path__ + "static/media/HyperGuest.5309cb37.png";